import abExperiments from '../../utils/abExperiments';
import isPageType from '../../utils/isPageType';
import { getUserId } from 'dibs-cookie-jar';

require('../../scss/tradeOnboarding.scss');

const { PAGE_TYPE } = require('../../utils/pageConstants');
const {
    loadOnboardingModal,
    hasSeenModal,
    getModalType,
    fetchTradeUserData,
    LABEL_PDP,
    LABEL_SEARCH_BROWSE
} = require('../../utils/tradeOnboardingHelper');

const showNewOnboardingFlow = () => {
    if (abExperiments.tradeOnboardingFlow) {
        setTimeout(() => abExperiments.tradeOnboardingFlow.resolve(false), 1500);
        return abExperiments.tradeOnboardingFlow;
    } else {
        return Promise.resolve(false);
    }
};

function tradeOnboardingRule() {
    const isBlacklistedPage = isPageType([PAGE_TYPE.CHECKOUT, PAGE_TYPE.SOURCING]);
    if (!getUserId(document.cookie) || isBlacklistedPage || hasSeenModal()) {
        return Promise.resolve(false);
    }

    return fetchTradeUserData().then(({isVerifiedTrade}) => {
        if (!isVerifiedTrade) {
            return Promise.resolve(false);
        } else {
            return Promise.resolve(true);
        }
    }).catch(err => {
        console.error(err);
        return Promise.resolve(false);
    });

};

const tradeOnboardingShow = () => (dispatch) => {
    const label = isPageType(PAGE_TYPE.PDP)
        ? LABEL_PDP
        : LABEL_SEARCH_BROWSE;
    return Promise.all([fetchTradeUserData(), showNewOnboardingFlow()])
        .then(([{email}, showNewFlow]) => {
            return loadOnboardingModal({
                buyerEmail: email,
                showNewFlow,
                trackingLabel: `modal - ${label}`
            })
            .then(() => (dispatch({
                success: true,
                type: getModalType()
            })));
        });
};

module.exports = {
    name: "tradeOnboarding",
    priority: 450,
    rule: tradeOnboardingRule,
    action: tradeOnboardingShow
};



// WEBPACK FOOTER //
// ./src/notificationQueue/globalNotifications/tradeOnboarding.js